import React, { useEffect, useRef, useState } from 'react';
import { useFeatureServices } from 'src/feature-app';
import { EsOneformCoreServiceV1 } from 'src/feature-service/es-oneform-core-feature-service/types';
import { IdPerson } from 'src/types';
import { BajaComunicacionesForm } from '.';
import { createPincodeEntity } from '../dps-utils';
import { LoadingEncuestas } from 'src/components';

export interface BajaComunicacionesProps {
  idPerson: IdPerson;
  handleError: () => void;
}

export function BajaComunicacionesController() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [ campaign, setCampaign ] = useState(null);

  const dpsDataRef = useRef(null);
  const idPersonRef = useRef(null);
  const oneFormService = useFeatureServices()['es:oneform-core'] as EsOneformCoreServiceV1;

  const handleNext = (value: any) => { };
  const handleComplete = () => {
    const dpsData = oneFormService.getDpsData();
    const { campaign } = dpsData;
    setCampaign(campaign);

    if (dpsData.pincode === null || dpsData.pincode.noPincodeFound || dpsData.pincode.pincodeError) {
      handleError();
    } else if (dpsData.pincode.pincodeUsed) {
      setLoading(false);
    } else {
      const idPerson = createPincodeEntity(dpsData, 'PERSON');

      dpsDataRef.current = dpsData;
      idPersonRef.current = idPerson;
      setLoading(false);
    }
  };

  const handleError = () => {
    setError(true);
    setLoading(false);
  };

  useEffect(() => {
    const oneFormCoreDpsIsLoaded = oneFormService.getLoadedState();

    oneFormCoreDpsIsLoaded.subscribe({
      next(value) {
        handleNext(value);
      },
      error(err) {
        console.error(err);
        handleError();
      },
      complete() {
        handleComplete();
      },
    });
  }, []);

  if (loading) {
    return <LoadingEncuestas/>;
  } else if (error) {
    return (
      <BajaComunicacionesForm
        campaign = { campaign }
      />
    );
  } else {
    return (
      <BajaComunicacionesForm
        dpsData={dpsDataRef.current}
        idPerson={idPersonRef.current}
        campaign = { campaign }
      />
    );
  }
}
